/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_UpgradingInputs */



/**
* | output |
* | --- |
* | "Upgrading to Team…" |
*
* @param {Sub_Dashboard_UpgradingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_upgrading = /** @type {((inputs?: Sub_Dashboard_UpgradingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_UpgradingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade auf Team wird durchgeführt…")
	return /** @type {LocalizedString} */ ("Upgrading to Team…")
});